export const GALLERY_SIZE = 8
